import { teamEmailAddressSchema } from "@redotech/redo-marketing-core-common/email/domain-verification";
import * as z from "zod";

export const getDkimVerifiedFromAddressesForTeam = {
  name: "getDkimVerifiedFromAddressesForTeam" as const,
  input: z.object({ teamId: z.string() }),
  output: z.array(teamEmailAddressSchema),
};
